import styled from "styled-components";
import { motion } from "framer-motion";

export const ClientsSection = styled.section`
  padding: 80px 0;
  text-align: center;
  position: relative;
  overflow: hidden;

  h3 {
    color: #1F514C;
    margin-bottom: 48px;
    font-size: 24px;
  }

  @media (max-width: 768px) {
    padding: 48px 0;
    
    h3 {
      margin-bottom: 32px;
    }
  }
`;

export const LogoContainer = styled(motion.div)`
  width: 100%;
  position: relative;
`;

export const InfiniteScrollWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  
  &::before, &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100px;
    z-index: 2;
    pointer-events: none;
  }
  
  &::before {
    left: 0;
    background: linear-gradient(to right, #fff, transparent);
  }
  
  &::after {
    right: 0;
    background: linear-gradient(to left, #fff, transparent);
  }
`;

export const LogoScroller = styled(motion.div)`
  display: flex;
  gap: 60px;
  padding: 20px 0;
  width: max-content;
  animation: scroll 35s linear infinite;

  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }
`;

export const LogoItem = styled(motion.div)`
  flex-shrink: 0;
  width: 180px;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  background: white;
  border-radius: 12px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    opacity: 0.8;
    transition: opacity 0.3s ease;
  }

  &:hover {
    img {
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    width: 180px;
    height: 90px;
  }
`;